import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7076/Marketing";
	}
	generateEventSubscriptions(e) {
		let t = this.baseUrl + "/GenerateEventSubscriptions";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGenerateEventSubscriptions(e)));
	}
	processGenerateEventSubscriptions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	createMarketingPackageTemplate(e, t) {
		let n = this.baseUrl + "/CreateMarketingPackageTemplate";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processCreateMarketingPackageTemplate(e)));
	}
	processCreateMarketingPackageTemplate(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	deleteMarketingPackageTemplate(e, t) {
		let n = this.baseUrl + "/DeleteMarketingPackageTemplate";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processDeleteMarketingPackageTemplate(e)));
	}
	processDeleteMarketingPackageTemplate(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getMarketingPackageTemplatesForAgent(e) {
		let t = this.baseUrl + "/GetMarketingPackageTemplatesForAgent";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetMarketingPackageTemplatesForAgent(e)));
	}
	processGetMarketingPackageTemplatesForAgent(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return U("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetMarketingPackageTemplates(e, t) {
		let n = this.baseUrl + "/StaffGetMarketingPackageTemplates?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetMarketingPackageTemplates(e)));
	}
	processStaffGetMarketingPackageTemplates(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateMarketingPackageTemplate(e, t) {
		let n = this.baseUrl + "/UpdateMarketingPackageTemplate";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateMarketingPackageTemplate(e)));
	}
	processUpdateMarketingPackageTemplate(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateMarketingPackageTemplateOrder(e, t) {
		let n = this.baseUrl + "/UpdateMarketingPackageTemplateOrder";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateMarketingPackageTemplateOrder(e)));
	}
	processUpdateMarketingPackageTemplateOrder(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	completeMarketingPackageStep(e, t) {
		let n = this.baseUrl + "/CompleteMarketingPackageStep";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processCompleteMarketingPackageStep(e)));
	}
	processCompleteMarketingPackageStep(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getMarketingPackage(e, t) {
		let n = this.baseUrl + "/GetMarketingPackage?";
		if (e == null) throw new globalThis.Error("The parameter 'marketingPackageId' must be defined and cannot be null.");
		n += "marketingPackageId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetMarketingPackage(e)));
	}
	processGetMarketingPackage(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return U("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getMarketingPackages(e, t) {
		let n = this.baseUrl + "/GetMarketingPackages?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetMarketingPackages(e)));
	}
	processGetMarketingPackages(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return U("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	removeMarketingPackageSubmission(e, t) {
		let n = this.baseUrl + "/RemoveMarketingPackageSubmission";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processRemoveMarketingPackageSubmission(e)));
	}
	processRemoveMarketingPackageSubmission(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetMarketingPackage(e, t) {
		let n = this.baseUrl + "/StaffGetMarketingPackage?";
		if (e == null) throw new globalThis.Error("The parameter 'marketingPackageId' must be defined and cannot be null.");
		n += "marketingPackageId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetMarketingPackage(e)));
	}
	processStaffGetMarketingPackage(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetMarketingPackages(e, t) {
		let n = this.baseUrl + "/StaffGetMarketingPackages?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetMarketingPackages(e)));
	}
	processStaffGetMarketingPackages(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	beginMarketingPackage(e, t) {
		let n = this.baseUrl + "/BeginMarketingPackage";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processBeginMarketingPackage(e)));
	}
	processBeginMarketingPackage(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	loadMarketingPackageForm(e, t) {
		let n = this.baseUrl + "/LoadMarketingPackageForm?";
		if (e == null) throw new globalThis.Error("The parameter 'formId' must be defined and cannot be null.");
		n += "formId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processLoadMarketingPackageForm(e)));
	}
	processLoadMarketingPackageForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	saveMarketingPackage(e, t) {
		let n = this.baseUrl + "/SaveMarketingPackage";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSaveMarketingPackage(e)));
	}
	processSaveMarketingPackage(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	sendMarketingPackage(e, t) {
		let n = this.baseUrl + "/SendMarketingPackage";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSendMarketingPackage(e)));
	}
	processSendMarketingPackage(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	submitMarketingPackage(e, t) {
		let n = this.baseUrl + "/SubmitMarketingPackage";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSubmitMarketingPackage(e)));
	}
	processSubmitMarketingPackage(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getMarketingItemTemplatesForAgent(e) {
		let t = this.baseUrl + "/GetMarketingItemTemplatesForAgent";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetMarketingItemTemplatesForAgent(e)));
	}
	processGetMarketingItemTemplatesForAgent(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setMarketingItemTemplates(e, t) {
		let n = this.baseUrl + "/SetMarketingItemTemplates";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetMarketingItemTemplates(e)));
	}
	processSetMarketingItemTemplates(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetMarketingItemTemplates(e, t) {
		let n = this.baseUrl + "/StaffGetMarketingItemTemplates?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (W(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetMarketingItemTemplates(e)));
	}
	processStaffGetMarketingItemTemplates(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return U("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.And = "And", e.Or = "Or", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.Manual = "Manual", e.DocuSign = "DocuSign", e.Email = "Email", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.EQ = "EQ", e.NEQ = "NEQ", e.LT = "LT", e.GT = "GT", e.LTEQ = "LTEQ", e.GTEQ = "GTEQ", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.SellerSolicitorEarlyDeposit = "SellerSolicitorEarlyDeposit", e.ContractExchange = "ContractExchange", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.SellerSolicitorEarlyDeposit = "SellerSolicitorEarlyDeposit", e.ContractExchange = "ContractExchange", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.None = "None", e.ForwardAndBack = "ForwardAndBack", e.BackAndReview = "BackAndReview", e.BackAndSubmit = "BackAndSubmit", e.Forward = "Forward", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Send = "Send", e.GeneratePdf = "GeneratePdf", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.Price = "Price", e.Complimentary = "Complimentary", e.AgentToFill = "AgentToFill", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Portals = "Portals", e.PrintCollateral = "PrintCollateral", e.Media = "Media", e.SocialAgent = "SocialAgent", e.SocialRexReach = "SocialRexReach", e.Other = "Other", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Item = "Item", e.Group = "Group", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Price = "Price", e.Complimentary = "Complimentary", e.AgentToFill = "AgentToFill", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Portals = "Portals", e.PrintCollateral = "PrintCollateral", e.Media = "Media", e.SocialAgent = "SocialAgent", e.SocialRexReach = "SocialRexReach", e.Other = "Other", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.ConfirmedLaunchDate = "ConfirmedLaunchDate", e.PropertyOnMarket = "PropertyOnMarket", e.OffMarket = "OffMarket", e.LaunchDateToBeConfirmed = "LaunchDateToBeConfirmed", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.Complete = "Complete", e.Future = "Future", e.FutureDisabled = "FutureDisabled", e.Invalid = "Invalid", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), V = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.SellerSolicitorEarlyDeposit = "SellerSolicitorEarlyDeposit", e.ContractExchange = "ContractExchange", e;
}({}), H = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isMarketingApiException = !0;
	static isMarketingApiException(e) {
		return e.isMarketingApiException === !0;
	}
};
function U(e, t, n, r, i) {
	throw i ?? new H(e, t, n, r, null);
}
function W(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var G = "marketing";
function K(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var q = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), K(r);
}, J = ({ baseApiUri: e, devMode: t, localUris: n }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	let r = n?.[G];
	return t && r ? r : `${e}/${G}`;
}, Y = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = J(i), u = c, d = q(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(q(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, X = a({}), Z = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = Y(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(X.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, Q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createMarketingPackageTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createMarketingPackageTemplate: u,
		createMarketingPackageTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ee = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.deleteMarketingPackageTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		deleteMarketingPackageTemplate: u,
		deleteMarketingPackageTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, $ = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(X), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getMarketingPackageTemplatesForAgent"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getMarketingPackageTemplatesForAgent(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, te = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getMarketingPackageTemplatesForAgent"] });
	}, e[0] = t, e[1] = n), n;
}, ne = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["staffGetMarketingPackageTemplates", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetMarketingPackageTemplates(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetMarketingPackageTemplates", e] });
	}, e[0] = t, e[1] = n), n;
}, ie = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateMarketingPackageTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateMarketingPackageTemplate: u,
		updateMarketingPackageTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ae = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateMarketingPackageTemplateOrder(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateMarketingPackageTemplateOrder: u,
		updateMarketingPackageTemplateOrderPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, oe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.completeMarketingPackageStep(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		completeMarketingPackageStep: u,
		completeMarketingPackageStepPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, se = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["getMarketingPackage", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getMarketingPackage(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getMarketingPackage", e] });
	}, e[0] = t, e[1] = n), n;
}, le = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["getMarketingPackages", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getMarketingPackages(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ue = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getMarketingPackages", e] });
	}, e[0] = t, e[1] = n), n;
}, de = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removeMarketingPackageSubmission(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removeMarketingPackageSubmission: u,
		removeMarketingPackageSubmissionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, fe = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["staffGetMarketingPackage", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetMarketingPackage(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, pe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetMarketingPackage", e] });
	}, e[0] = t, e[1] = n), n;
}, me = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["staffGetMarketingPackages", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetMarketingPackages(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, he = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetMarketingPackages", e] });
	}, e[0] = t, e[1] = n), n;
}, ge = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.beginMarketingPackage(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		beginMarketingPackage: u,
		beginMarketingPackagePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, _e = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["loadMarketingPackageForm", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.loadMarketingPackageForm(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ve = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["loadMarketingPackageForm", e] });
	}, e[0] = t, e[1] = n), n;
}, ye = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.saveMarketingPackage(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		saveMarketingPackage: u,
		saveMarketingPackagePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, be = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.sendMarketingPackage(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		sendMarketingPackage: u,
		sendMarketingPackagePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, xe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.submitMarketingPackage(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		submitMarketingPackage: u,
		submitMarketingPackagePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Se = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(X), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getMarketingItemTemplatesForAgent"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getMarketingItemTemplatesForAgent(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getMarketingItemTemplatesForAgent"] });
	}, e[0] = t, e[1] = n), n;
}, we = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(X), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setMarketingItemTemplates(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setMarketingItemTemplates: u,
		setMarketingItemTemplatesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Te = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(X), s;
	n[0] === e ? s = n[1] : (s = ["staffGetMarketingItemTemplates", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetMarketingItemTemplates(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ee = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetMarketingItemTemplates", e] });
	}, e[0] = t, e[1] = n), n;
};
//#endregion
export { S as DownloadDocumentTypes, p as ElementConditionAndOr, h as EnvelopeSubmissionModelStatus, m as EnvelopeSubmissionModelType, _ as EnvelopeSubmissionRecipientStakeholderType, g as EnvelopeSubmissionRecipientStatus, v as ExpressionOperator, C as FormPageActionButtonType, w as FormPageSubmitType, b as FormState, T as FormSubmissionRequestState, y as FormType, x as GeneratedDocumentTypes, E as LandAreaDetailsTotalLandAreaType, X as MarketingApiContext, H as MarketingApiException, Z as MarketingApiProvider, f as MarketingClient, O as MarketingItemTemplateBaseModelCategory, D as MarketingItemTemplateBaseModelItemType, j as MarketingItemTemplateModelCategory, A as MarketingItemTemplateModelItemType, k as MarketingItemTemplateModelTemplateType, M as MarketingLaunchDetailsLaunchType, N as MarketingPackageModelCampaignFlowDisplayStatus, P as MarketingPackageProjectionDisplayStatus, G as MarketingRoute, F as PageStatusStatus, L as PropertyDetailsBuiltOnOrVacantLandType, I as PropertyDetailsRuralType, R as SendFormClientDetailsStakeholderType, B as SendFormSubmissionModelState, z as SigningOrderGroups, V as UploadedDocumentDocumentType, ge as useBeginMarketingPackage, oe as useCompleteMarketingPackageStep, Q as useCreateMarketingPackageTemplate, ee as useDeleteMarketingPackageTemplate, Se as useGetMarketingItemTemplatesForAgent, se as useGetMarketingPackage, $ as useGetMarketingPackageTemplatesForAgent, le as useGetMarketingPackages, Ce as useInvalidateUseGetMarketingItemTemplatesForAgent, ce as useInvalidateUseGetMarketingPackage, te as useInvalidateUseGetMarketingPackageTemplatesForAgent, ue as useInvalidateUseGetMarketingPackages, ve as useInvalidateUseLoadMarketingPackageForm, Ee as useInvalidateUseStaffGetMarketingItemTemplates, pe as useInvalidateUseStaffGetMarketingPackage, re as useInvalidateUseStaffGetMarketingPackageTemplates, he as useInvalidateUseStaffGetMarketingPackages, _e as useLoadMarketingPackageForm, Y as useMarketingClientContext, de as useRemoveMarketingPackageSubmission, ye as useSaveMarketingPackage, be as useSendMarketingPackage, we as useSetMarketingItemTemplates, Te as useStaffGetMarketingItemTemplates, fe as useStaffGetMarketingPackage, ne as useStaffGetMarketingPackageTemplates, me as useStaffGetMarketingPackages, xe as useSubmitMarketingPackage, ie as useUpdateMarketingPackageTemplate, ae as useUpdateMarketingPackageTemplateOrder };
